import { useInviteEmployee } from './useEmployees';

import { AddEmployeeToCompany } from './types';

export function useAddEmployee(companyId: string) {
  const addEmployeeMutation = useInviteEmployee(companyId);

  const addEmployee = async (
    values: AddEmployeeToCompany,
    onAdd: () => void
  ) => {
    addEmployeeMutation.mutate(
      {
        email: values.email,
        department_id: values.departmentId,
        role: values.role,
        first_name: values.firstName || undefined,
        last_name: values.lastName || undefined,
        locale: 'ru',
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || 'Europe/Moscow',
      },
      { onSuccess: onAdd }
    );
  };

  return {
    addEmployee,
    isPending: addEmployeeMutation.isPending,
    isError: addEmployeeMutation.isError,
    isSuccess: addEmployeeMutation.isSuccess,
    error: addEmployeeMutation.error,
    errorReset: addEmployeeMutation.reset,
    data: addEmployeeMutation.data,
  };
}
